import { Phrase } from './phrase.class';
import { Dommage } from './dommage.class';
import { Required } from '@decorators/entity-required.decorator';
import { Primary } from '@decorators/entity-primary.decorator';

export class PhraseDommage {
	@Required
	@Primary
	id: number;

	@Required
	mandatory: boolean;

	@Required
	sort: number;

	@Required
	phrase: Phrase;

	phraseId: number;
	parentPhraseDommageId: number;

	@Required
	dommage: Dommage;
	dommageId: number;
}